// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Controller pro subjekty a příslušné entity - uživatele, společnosti, adresy, karty jaroslav.hudec@marbes.cz / 26.08.2018. Generated from cz.marbes.cgo.controller.SubjektController.
 */
export default class SubjektApi {
    /**
     * 
     *
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.SpolecnostPredvolbyVO
     */
    static getSpolecnostPredvolby(spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnosti/${spolecnostId}/predvolby`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení detailu uživatele. @param uzivatelId ID uživatele @return detail uživatele
     *
     * @param uzivatelId 
     * @return cz.marbes.cgo.controller.vo.UzivatelVO
     */
    static getUzivatel(uzivatelId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Aktualizace předvoleb uživatele. @param uzivatelPredvolbyVO aktualizované předvolby uživatele @param uzivatelId ID uživatele, musí odpovídat ID ve VO @return aktualizovaný uživatel
     *
     * @param uzivatelPredvolbyVO 
     * @param uzivatelId 
     * @return cz.marbes.cgo.controller.vo.UzivatelVO
     */
    static updateUzivatelPredvolby(uzivatelPredvolbyVO, uzivatelId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatele/${uzivatelId}/predvolby`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, uzivatelPredvolbyVO, headers));
    }

    /**
     * Vrátí výchozí hodnoty uživatele, volitelně na základě nastavení jeho společnosti a provozovatele. @param uzivatelId ID uživatele @param spolecnostId ID aktivní společnosti daného uživatele, nepovinné @return výchozí hodnoty uživatele s ohledem na nastavení uživatele, společnosti a provozovatele
     *
     * @param uzivatelId 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.UzivatelVychoziHodnotyVO
     */
    static getUzivatelVychoziHodnoty(uzivatelId, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatele/${uzivatelId}/vychoziHodnoty`;
        const headers = undefined;
        const params = { spolecnostId };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Aktualizace údajů uživatele. @param uzivatelVO aktualizované údaje uživatele @param uzivatelId ID uživatele, musí odpovídat ID ve VO @return aktualizovaný uživatel
     *
     * @param uzivatelVO 
     * @param uzivatelId 
     * @return cz.marbes.cgo.controller.vo.UzivatelVO
     */
    static updateUzivatel(uzivatelVO, uzivatelId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatele/${uzivatelId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, uzivatelVO, headers));
    }

    /**
     * Založení nové adresy uživatele. @param adresaVO data adresy @param uzivatelId ID uživatele @param spolecnostId ID společnosti, za kterou uživatel vystupuje @return vytvořená adresa uživatele
     *
     * @param adresaVO 
     * @param uzivatelId 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.AdresaVO
     */
    static createAdresaUzivatel(adresaVO, uzivatelId, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}/adresy`;
        const headers = undefined;
        const params = { spolecnostId };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, adresaVO, headers));
    }

    /**
     * Aktualizace karty společnosti. @param kartaVO aktualizovaná data karty @param spolecnostId ID společnosti, musí odpovídat ID ve VO @param kartaId ID karty, musí odpovídat ID ve VO @return aktualizovaná karta společnosti
     *
     * @param kartaVO 
     * @param spolecnostId 
     * @param kartaId 
     * @return cz.marbes.cgo.controller.vo.KartaVO
     */
    static updateKarta(kartaVO, spolecnostId, kartaId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/karty/${kartaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, kartaVO, headers));
    }

    /**
     * Založení nové karty společnosti. @param kartaVO data karty @param spolecnostId ID společnosti které karta patří @return vytvořená karta společnosti
     *
     * @param kartaVO 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.KartaVO
     */
    static createKarta(kartaVO, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/karty`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kartaVO, headers));
    }

    /**
     * Aktualizace adresy uživatele. @param adresaVO aktualizované údaje adresy @param uzivatelId ID uživatele, musí odpovídat ID ve VO @param adresaId ID adresy, musí odpovídat ID ve VO @param spolecnostId ID společnosti, za kterou uživatel vystupuje @return aktualizovaná adresa uživatele
     *
     * @param adresaVO 
     * @param uzivatelId 
     * @param adresaId 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.AdresaVO
     */
    static updateAdresaUzivatel(adresaVO, uzivatelId, adresaId, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}/adresy/${adresaId}`;
        const headers = undefined;
        const params = { spolecnostId };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, adresaVO, headers));
    }

    /**
     * Načtení oprávnění na konkrétní společnost. @param spolecnostId ID společnosti @return oprávnění na společnost
     *
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.SpolecnostRightsVO
     */
    static getSpolecnostRights(spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/rights`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení konkrétní adresy společnosti. @param spolecnostId ID společnosti @param adresaId ID adresy @return adresa společnosti
     *
     * @param spolecnostId 
     * @param adresaId 
     * @return cz.marbes.cgo.controller.vo.AdresaVO
     */
    static getAdresaSpolecnost(spolecnostId, adresaId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/adresa/${adresaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Aktualizace seznamu společností, na které je vázán daný uživatel. @param spolecnostList seznam společností @param uzivatelId ID uživatele @param clearOther pokud je nastaveno true, je předaný seznam finální, jinak dojde pouze k přidání nových záznamů @return objekt uživatele
     *
     * @param spolecnostList 
     * @param uzivatelId 
     * @param clearOther 
     * @return cz.marbes.cgo.controller.vo.UzivatelVO
     */
    static updateUzivatelSpolecnosti(spolecnostList, uzivatelId, clearOther) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}/spolecnosti`;
        const headers = undefined;
        const params = { clearOther };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, spolecnostList, headers));
    }

    /**
     * Načtení konkrétní adresy uživatele. @param uzivatelId ID uživatele @param adresaId ID adresy @param spolecnostId ID společnosti, za kterou uživatel vystupuje @return adresa uživatele
     *
     * @param uzivatelId 
     * @param adresaId 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.AdresaVO
     */
    static getAdresaUzivatel(uzivatelId, adresaId, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}/adresa/${adresaId}`;
        const headers = undefined;
        const params = { spolecnostId };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení oprávnění na konkrétního uživatele. @param uzivatelId ID uživatele @return oprávnění na uživatele
     *
     * @param uzivatelId 
     * @return cz.marbes.cgo.controller.vo.UzivatelRightsVO
     */
    static getUzivatelRights(uzivatelId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}/rights`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení adres konkrétního uživatele. @param uzivatelId ID uživatele @param spolecnostId ID společnosti, za kterou uživatel vystupuje @param neaktivni zda načíst pouze neaktivní (true), pouze aktivní (false) nebo všechny (null) adresy @return seznam adres uživatele odpovídající parametrům
     *
     * @param uzivatelId 
     * @param spolecnostId 
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.AdresaVO>
     */
    static getAdresyUzivatel(uzivatelId, spolecnostId, neaktivni) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}/adresy`;
        const headers = undefined;
        const params = { spolecnostId, neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Připojení ceníku ke společnosti.
     *
     * @param spolecnostId 
     * @param cenikId 
     */
    static pripojCenikSpolecnost(spolecnostId, cenikId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/cenik/${cenikId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Načtení detailu uživatele dle loginu. @param loginname ID uživatele @return detail uživatele
     *
     * @param loginname 
     * @return cz.marbes.cgo.controller.vo.UzivatelVO
     */
    static findUzivatelByLogin(loginname) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/findbylogin`;
        const headers = undefined;
        const params = { loginname };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení adres společnosti. @param spolecnostId ID společnosti @param neaktivni zda načíst pouze neaktivní (true), pouze aktivní (false) nebo všechny (null) adresy @return seznam adres společnosti odpovídající parametrům
     *
     * @param spolecnostId 
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.AdresaVO>
     */
    static getAdresySpolecnost(spolecnostId, neaktivni) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/adresy`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení detailu konkrétní společnosti. @param spolecnostId ID společnosti @return detail společnosti
     *
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.SpolecnostVO
     */
    static getSpolecnost(spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Aktualizace předvoleb společnosti. @param spolecnostPredvolbyVO VO s předvolbami @param spolecnostId ID společnosti, musí odpovídat ID ve VO @return aktualizovaná společnost
     *
     * @param spolecnostPredvolbyVO 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.SpolecnostVO
     */
    static updateSpolecnostPredvolby(spolecnostPredvolbyVO, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnosti/${spolecnostId}/predvolby`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, spolecnostPredvolbyVO, headers));
    }

    /**
     * 
     *
     * @param spolecnostId 
     * @param pobockaId 
     */
    static deleteVydejPobockaSpolecnosti(spolecnostId, pobockaId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/vydejpobocky/${pobockaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Načtení seznamu společností. @param findText volitelný fulltext filtr @param neaktivni zda vrátit jen neaktivní (true), jen aktivní (false) nebo všechny (null) společnosti @return seznam společností odpovídající parametrům
     *
     * @param findtext 
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.SpolecnostVO>
     */
    static getSpolecnosti(findtext, neaktivni) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnosti`;
        const headers = undefined;
        const params = { findtext, neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vytvoření nové společnosti. @param spolecnostVO data společnosti @return vytvořená společnost
     *
     * @param spolecnostVO 
     * @return cz.marbes.cgo.controller.vo.SpolecnostVO
     */
    static createSpolecnost(spolecnostVO) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnosti`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, spolecnostVO, headers));
    }

    /**
     * Založení nového uživatele. @param uzivatelVO údaje uživatele @param spolecnostId ID společnosti, pokud je předáno, je uživatel automaticky přiřazen k dané společnosti @return založený uživatel
     *
     * @param uzivatelVO 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.UzivatelVO
     */
    static createUzivatel(uzivatelVO, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatele`;
        const headers = undefined;
        const params = { spolecnostId };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, uzivatelVO, headers));
    }

    /**
     * Spustí import uživatelů z adresářové služby
     *
     */
    static importUsersFromAD() {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/importFromAD`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param spolecnostId 
     * @param addvydejni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.PobockaVO>
     */
    static getVydejPobockySpolecnosti(spolecnostId, addvydejni) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/vydejpobocky`;
        const headers = undefined;
        const params = { addvydejni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení uživatelů ve společnosti. @param spolecnostId ID společnosti @return seznam uživatelů ve společnosti
     *
     * @param spolecnostId 
     * @return java.util.List<cz.marbes.cgo.controller.vo.UzivatelVO>
     */
    static getUzivateleSpolecnost(spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/uzivatele`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Spustí import uživatelů z adresářové služby
     *
     * @return cz.marbes.cgo.controller.vo.AdImportVO
     */
    static isImportFromADEnabled() {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/importFromAD/enabled`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení seznamu entit představující uživatele a volitelně společnost. Pokud je uživatel např. součástí dvou společností, je ve výsledném listu dvakrát - jednou za každou společnost. Pokud uživatel není součástí žádné společnosti, je ve výsledném listu právě jednou, bez vazby na společnost. @param findText volitelný fulltext @return seznam uživatelů a jejich společností
     *
     * @param findtext 
     * @return java.util.List<cz.marbes.cgo.controller.vo.UzivatelASpolecnostVO>
     */
    static getUzivateleASpolecnosti(findtext) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivateleaspolecnosti`;
        const headers = undefined;
        const params = { findtext };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení uživatelů. @param findText volitelný fulltext @param neaktivni zda načíst pouze neaktivní (false), pouze aktivní (true) nebo všechny (null) uživatele @param mimoSpolecnostId ID společnosti, pokud je předáno, uživatelé této společnosti nebudou ve výsledném seznamu @return seznam uživatelů odpovídajících parametrům
     *
     * @param findtext 
     * @param neaktivni 
     * @param mimoSpolecnostId 
     * @return java.util.List<cz.marbes.cgo.controller.vo.UzivatelVO>
     */
    static getUzivatele(findtext, neaktivni, mimoSpolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatele`;
        const headers = undefined;
        const params = { findtext, neaktivni, mimoSpolecnostId };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Nastavení adresy jako výchozí pro konkrétního uživatele. @param uzivatelId ID uživatele @param adresaId ID adresy @param spolecnostId ID společnosti, za kterou uživatel vystupuje @return aktualizovaná adresa
     *
     * @param uzivatelId 
     * @param adresaId 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.AdresaVO
     */
    static setAdresaVychozi(uzivatelId, adresaId, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}/adresy/${adresaId}/setvychozi`;
        const headers = undefined;
        const params = { spolecnostId };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, 0, headers));
    }

    /**
     * Aktualizace adresy společnosti. @param adresaVO aktualizovaná data adresy @param spolecnostId ID společnosti, musí odpovídat ID ve VO @param adresaId ID adresy, musí odpovídat ID ve VO @return aktualizovaná adresa
     *
     * @param adresaVO 
     * @param spolecnostId 
     * @param adresaId 
     * @return cz.marbes.cgo.controller.vo.AdresaVO
     */
    static updateAdresaSpolecnost(adresaVO, spolecnostId, adresaId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/adresy/${adresaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, adresaVO, headers));
    }

    /**
     * Odpojení uživatele od společnosti. @param spolecnostId ID společnosti @param uzivatelId ID uživatele
     *
     * @param spolecnostId 
     * @param uzivatelId 
     */
    static unlinkSpolecnostUzivatel(spolecnostId, uzivatelId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/${uzivatelId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Založení nové adresy společnosti. @param adresaVO data adresy @param spolecnostId ID společnosti které adresa patří @return vytvořená adresa
     *
     * @param adresaVO 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.AdresaVO
     */
    static createAdresaSpolecnost(adresaVO, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/adresy`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, adresaVO, headers));
    }

    /**
     * Načtení seznamu společností ke kterým je uživatel přiřazen. @param uzivatelId ID uživatele @param neaktivni zda načíst pouze neaktivní (true), pouze aktivní (false) nebo všechny (null) společnosti @return seznam společností uživatele
     *
     * @param uzivatelId 
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.SpolecnostVO>
     */
    static getSpolecnostiUzivatel(uzivatelId, neaktivni) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}/spolecnosti`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Připojení uživatele ke společnosti. @param spolecnostId ID společnosti @param uzivatelId ID uživatele
     *
     * @param spolecnostId 
     * @param uzivatelId 
     */
    static linkSpolecnostUzivatel(spolecnostId, uzivatelId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/${uzivatelId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Připojení ceníku ke společnosti.
     *
     * @param spolecnostId 
     * @param cenikId 
     */
    static odpojCenikSpolecnost(spolecnostId, cenikId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/cenik/${cenikId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Načtení karet uživatele. @param uzivatelId ID uživatele @param neaktivni zda načíst pouze neaktivní (true), pouze aktivní (false) nebo všechny (null) karty @return seznam karet uživatele
     *
     * @param uzivatelId 
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.KartaVO>
     */
    static getKartyUzivatel(uzivatelId, neaktivni) {
        const uri = serverContextPath + `/api/cgo/subjekt/uzivatel/${uzivatelId}/karty`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení karet společnosti. @param spolecnostId ID společnosti @param neaktivni zda načíst pouze neaktivní (true), pouze aktivní (false) nebo všechny (null) karty @return seznam karet společnosti
     *
     * @param spolecnostId 
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.KartaVO>
     */
    static getKartySpolecnost(spolecnostId, neaktivni) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/karty`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param spolecnostId 
     * @param pobockaId 
     */
    static createVydejPobockaSpolecnosti(spolecnostId, pobockaId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/vydejpobocky`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, pobockaId, headers));
    }

    /**
     * Aktualizace údajů společnosti. @param spolecnostVO aktualizovaná data společnosti @param spolecnostId ID společnosti, musí odpovídat ID ve VO @return aktualizovaná společnost
     *
     * @param spolecnostVO 
     * @param spolecnostId 
     * @return cz.marbes.cgo.controller.vo.SpolecnostVO
     */
    static updateSpolecnost(spolecnostVO, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnosti/${spolecnostId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, spolecnostVO, headers));
    }

    /**
     * Načtení konkrétní karty společnosti. @param spolecnostId ID společnosti @param kartaId ID karty @return karta společnosti
     *
     * @param spolecnostId 
     * @param kartaId 
     * @return cz.marbes.cgo.controller.vo.KartaVO
     */
    static getKartaSpolecnost(spolecnostId, kartaId) {
        const uri = serverContextPath + `/api/cgo/subjekt/spolecnost/${spolecnostId}/karta/${kartaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
